// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as EditOrderRepoManager from "./EditOrderRepoManager.bs.js";
import * as TicketingOrderRepoManager from "../../../order-dashboard/app/order/repo/order/TicketingOrderRepoManager.bs.js";

function fetchManualEditOrderReasons(onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchManualEditOrderReasons, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchOrderCancellationReasons(param, onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchOrderCancellationReasons, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateActualPartnerCollectedCash(param, onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.updateActualPartnerCollectedCash, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchOrderFareBreakup(param, onSuccess, onFailure, country) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchOrderFareBreakup, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateHasWaypoints(param, onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.updateHasWaypoints, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateDryRunDistance(param, onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.updateDryRunDistance, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateOrderStatus(param, onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.updateOrderStatus, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function cancelOrder(param, onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.cancelOrder, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function updateDeliveryNote(param, onSuccess, onFailure, country) {
  var RepoInstance = EditOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.updateDeliveryNote, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  fetchManualEditOrderReasons ,
  fetchOrderCancellationReasons ,
  updateActualPartnerCollectedCash ,
  fetchOrderFareBreakup ,
  updateHasWaypoints ,
  updateDryRunDistance ,
  updateOrderStatus ,
  cancelOrder ,
  updateDeliveryNote ,
  
}
/* EditOrderRepoManager Not a pure module */
